import { supabase } from '../supabaseClient'

const cache = new Map()
const CACHE_MS = 5 * 60 * 1000

function chaveCache(tipo, search) {
  return `${tipo}::${String(search || '').trim().toLowerCase()}`
}

/**
 * Pesquisa módulos (panels) ou inversores (inverters) na Solar Stack, via Edge Function.
 * @param {'panels'|'inverters'} tipo
 * @param {string} search
 * @returns {Promise<Array<{ id: string, marca: string, modelo: string, potencia: number|null, origem: string }>>}
 */
export async function buscarCatalogoSolarStack(tipo, search = '') {
  const key = chaveCache(tipo, search)
  const hit = cache.get(key)
  if (hit && Date.now() - hit.at < CACHE_MS) return hit.itens

  try {
    const { data, error } = await supabase.functions.invoke('solar-stack-search', {
      body: {
        tipo: tipo === 'inverters' ? 'inverters' : 'panels',
        search: String(search || '').trim(),
        page: 1,
        perPage: 25
      }
    })
    if (error) {
      console.warn('[Solar Stack] Falha na função:', error.message || error)
      return []
    }
    if (data && data.success === false) {
      console.warn('[Solar Stack]', data.error || 'Resposta sem sucesso')
      return []
    }
    const itens = Array.isArray(data?.itens) ? data.itens : []
    cache.set(key, { at: Date.now(), itens })
    return itens
  } catch (e) {
    console.warn('[Solar Stack] Exceção:', e?.message || e)
    return []
  }
}
